enum EMultiSelectionTypes {
  Experiment = 'Experiment',
  Files = 'Files',
}

export default EMultiSelectionTypes;
